import { ProjectType } from '../api/sophia';

interface ProjectTypeSelectorModalProps {
  isOpen: boolean;
  onClose: () => void;
  onSelectType: (type: ProjectType) => void;
  onSelectOptimization?: () => void;
}

export default function ProjectTypeSelectorModal({ isOpen, onClose, onSelectType, onSelectOptimization }: ProjectTypeSelectorModalProps) {
  if (!isOpen) return null;

  const handleSelect = (type: ProjectType) => {
    onSelectType(type);
  };

  return (
    <div className="fixed inset-0 overlay-in z-50 flex items-center justify-center bg-black bg-opacity-50">
      <div className="bg-white max-w-2xl w-full mx-4 shadow-xl">
        <div className="border-b border-gray-200 px-6 py-4 flex items-center justify-between">
          <h2 className="text-xl font-semibold text-gray-900">Seleziona Tipo Progetto</h2>
          <button
            type="button"
            onClick={onClose}
            className="text-gray-400 hover:text-gray-600 text-2xl leading-none"
          >
            ×
          </button>
        </div>

        <div className="p-6">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <button
              type="button"
              onClick={() => handleSelect('consultation')}
              className="group relative overflow-hidden bg-white border-2 border-gray-200 hover:border-[#688096] transition-all duration-300 p-6 text-left"
            >
              <div className="flex flex-col h-full">
                <div className="flex items-center gap-3 mb-3">
                  <i className="ti-search text-3xl text-[#688096]" aria-hidden="true" />
                  <h3 className="text-xl font-bold text-gray-900">Consultazione</h3>
                </div>
                <p className="text-gray-600 text-sm mb-4 flex-1">
                  Consulta e analizza i dati esistenti, visualizza statistiche e report.
                </p>
                <div className="flex items-center text-[#688096] font-semibold text-sm group-hover:translate-x-2 transition-transform duration-300">
                  <span>Seleziona</span>
                  <i className="ti-arrow-right ml-2" aria-hidden="true" />
                </div>
              </div>
            </button>

            <button
              type="button"
              onClick={() => {
                if (onSelectOptimization) {
                  onSelectOptimization();
                } else {
                  handleSelect('optimization');
                }
              }}
              className="group relative overflow-hidden bg-white border-2 border-gray-200 hover:border-[#9F6460] transition-all duration-300 p-6 text-left"
            >
              <div className="flex flex-col h-full">
                <div className="flex items-center gap-3 mb-3">
                  <i className="ti-settings text-3xl text-[#9F6460]" aria-hidden="true" />
                  <h3 className="text-xl font-bold text-gray-900">Ottimizzazione</h3>
                </div>
                <p className="text-gray-600 text-sm mb-4 flex-1">
                  Crea un nuovo piano ottimizzato basato sui dati storici e le previsioni.
                </p>
                <div className="flex items-center text-[#9F6460] font-semibold text-sm group-hover:translate-x-2 transition-transform duration-300">
                  <span>Seleziona</span>
                  <i className="ti-arrow-right ml-2" aria-hidden="true" />
                </div>
              </div>
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
